import routineReducerFactory from "./routineReducerFactory";
import {completeFairCart as completeFairCartRoutine} from "../actions/routines";

export const completeFairCart = routineReducerFactory(completeFairCartRoutine, {loading: false});